export default {
  listagem: {
    titulo_pagina: "Disposable Control Recipients",
    table: {
      empty: "No Vns found",
      nome: "Vns",
      empresa: "Company",
      resultado_descartavel: "Disposable Control Recipient",
      editar: "Edit"
    }
  },
  form: {
    titulo_pagina: {
      editar: "Edit Disposable Control Recipients"
    },
    fields: {
      vns: {
        label: "Vns",
        description: "Vns name"
      },
      report_control: {
        label: "Disposable Control Recipients",
        description: "Control results to be discarded by Vns"
      },
      botao_salvar: "Save Disposable Control Recipients"
    },
    update: {
      success: "Disposable control results updated successfully!",
      error: "Error updating disposable control results!"
    }
  }
}
